/**
 * @(#)2020/03/11.
 * 文件上传基础类
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import request from "../request";
import { merge, get, toArray, cloneDeep } from "../index";
import { last } from "lodash";
import { message } from "antd";

const urlToFile = function (url, uid, name) {
  let fileName = name;
  if (fileName == null) {
    let pos = url.lastIndexOf("/");
    fileName = decodeURIComponent(url.substring(pos + 1).split("?")[0]);
  }
  return {
    uid,
    url,
    name: fileName,
    status: "done",
    type: "custom",
  };
};

class BaseUpload {
  constructor(param) {
    const { ossFactory } = param;
    this.ossFactory = ossFactory;
    this._param = { ...param };
  }

  propsFormParams(file, baseParam = {}) {
    const result = get(this._param, "formParams", {});
    if (result instanceof Function) {
      return result(file, { ...cloneDeep(baseParam) });
    }
    return result;
  }

  getOssType(uploadType) {
    const ossType = {
      oss: "ALIYUNOSS",
      aws: "AMAZONS3",
      jd: "JDCLOUDS3",
      minio: "MINIO",
      huawei: "HUAWEIOBS",
      s3: "ALIYUNOSS",
    };
    return get(ossType, `${uploadType}`, "oss");
  }
  /**
   * 删掉字符串最后一个字符
   *
   * @static
   * @memberof BaseUpload
   */
  static removeLastStr = function (str) {
    const length = get(str, "length", 0);
    if (length <= 0) {
      return str;
    } else {
      let newStr = str;
      newStr = newStr.substring(0, newStr.length - 1);
      return newStr;
    }
  };

  /**
   * 删掉url最后一个斜杠，常用于拼接的时候干掉多余的斜杠
   *
   * @param {*} url
   */
  static removeLastSlash = function (url) {
    const length = get(url, "length", 0);
    if (length <= 0) {
      return url;
    } else {
      const lastStr = last([...url]);
      if (lastStr === "/") {
        return BaseUpload.removeLastStr(url);
      }
      return url;
    }
  };

  urlToFile_ = function (...args) {
    return urlToFile(...args);
  };

  /**
   * url转组件可显示形式
   * @param {string} url 文件url
   * @param {string} uid 文件id
   * @param {string||null} name 文件id
   *
   * @static
   * @memberof BaseUpload
   */
  static urlToFile = function (...args) {
    return urlToFile(...args);
  };

  /**
   * 凭证获得接口处理
   *
   * @param {*} param
   * @returns
   * @memberof BaseUpload
   */
  async requestPolicy(requestAction, ...args) {
    const handle = requestAction instanceof Function ? requestAction : request;
    let result = await handle(...args);
    if (this.ossFactory instanceof Function) {
      return this.ossFactory(result);
    }
    return result;
  }

  uploadRules = (file) => {
    const fileSize = get(this._param, "size", 0);
    const condtions = [
      {
        rule: () => fileSize === 0 || file.size / (1024 * 1024) <= fileSize,
        message: `超出上传文件限制，文件限制大小为${fileSize}MB`,
      },
      ...toArray(get(this._param, "rules", [])),
    ];
    for (let condtion of condtions) {
      if (!condtion.rule(file)) {
        message.error(condtion.message);
        return false;
      }
    }
    return true;
  };
}

export default BaseUpload;



// WEBPACK FOOTER //
// ./src/yx-widget/utils/upload/baseUpload.js